import api from '../../api/api';
import type { Login, FormValues, CurrentUser } from '../types';
import { VerifyFormValues } from '../verify-two-factor/types';

export interface ValidatorsProps {
  type: string;
  properties: Record<
    string,
    {
      type: string;
      minLength?: number;
      errorMessage: Record<string, string> | string;
    }
  >;
  required: string[];
}

export interface ValidatorResponse {
  data: {
    loginEmailSchema: ValidatorsProps;
  };
}

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<{ data: Login }, any>({
      query: (body: FormValues) => ({
        url: '/v1/auth/email',
        method: 'POST',
        body,
      }),
    }),
    generateTotp: build.mutation<{ data: Login }, any>({
      query: (body: { mfaToken: string }) => ({
        url: '/v1/auth/totp',
        method: 'POST',
        body,
      }),
    }),
    resetPassword: build.mutation<
      { data: any },
      {
        recoveryToken: string;
        password: string;
        email: string;
      }
    >({
      query: (body) => ({
        url: '/v1/recover/reset-password',
        method: 'POST',
        body,
      }),
    }),
    verify: build.mutation<{ data: { userId: string } }, any>({
      query: (body: VerifyFormValues) => ({
        url: '/v1/auth/totp/verify',
        method: 'POST',
        body,
      }),
    }),
    getValidators: build.query<ValidatorResponse, void>({
      query: () => ({
        url: '/v1/auth/validators',
      }),
    }),
    getCurrentUser: build.query<{ data: CurrentUser }, void>({
      query: () => ({
        url: '/v1/employees/whoami',
      }),
    }),
  }),
});

export const {
  useGetValidatorsQuery,
  useLoginMutation,
  useGetCurrentUserQuery,
  useLazyGetCurrentUserQuery,
  useVerifyMutation,
  useResetPasswordMutation,
  useGenerateTotpMutation,
} = authApi;

export const {
  endpoints: {
    login,
    getValidators,
    getCurrentUser,
    verify,
    resetPassword,
    generateTotp,
  },
} = authApi;
